var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['c-bcx-user-badge', _vm.badge.toLowerCase()]},[_c('shadow-root',[_c(_vm.badgeComponent,{tag:"component",on:{"click":function($event){return _vm.emit('badge-clicked')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }